
const TreeItemModel = require("@/appModel/Tree/TreeItemModel")
const SortUtil = require("@/appUtils/SortUtil")
const { file } = require("jszip")
const path = require("path")

class FileListViewModel {
  constructor(tenantId, projectId, nodeId){
    this.tenantId = tenantId
    this.projectId = projectId
    this.treeItems = []
    this.nodeId = nodeId
    this.list = []
    this.isNew = true
    this.nodeData = null
    this.treeData = null
    // this.parentNode = parentNode
  }
  
  async init(){
    const sk = TreeItemModel.createSk(this.projectId, this.nodeId)
    
    const itemList = await TreeItemModel.listLsiStr1(sk, this.tenantId)
    //backimage, map, nobackimage, inspectmaster, folder, file
    let fileList = await SortUtil.sort(itemList.filter(item => {return item.treeItem.type == "file"}), "treeItem.label", "ascending", true);
    let folderList = await SortUtil.sort(itemList.filter(item => {return item.treeItem.type == "folder"}), "treeItem.label", "ascending", true);
    let backImageList = await SortUtil.sort(itemList.filter(item => {return item.treeItem.type == "backimage"}), "treeItem.label", "ascending", true);
    let mapList = await SortUtil.sort(itemList.filter(item => {return item.treeItem.type == "map"}), "treeItem.label", "ascending", true);
    let nobackimageList = await SortUtil.sort(itemList.filter(item => {return item.treeItem.type == "nobackimage"}), "treeItem.label", "ascending", true);
    
    let linedList = []

    folderList.forEach(item => {
      linedList.push(item)
    })
    backImageList.forEach(item => {
      linedList.push(item)
    })
    mapList.forEach(item => {
      linedList.push(item)
    })
    nobackimageList.forEach(item => {
      linedList.push(item)
    })
    fileList.forEach(item => {
      linedList.push(item)
    })
    
    this.list = linedList
    
  }

}
module.exports = FileListViewModel;